var menu = document.querySelector('.navbar-toggler');
if (menu) {
    menu.addEventListener('click', function() {
        document.body.classList.toggle('overlay');
    });
}